/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-11 11:51:57
 */
import { Button, Popconfirm, Space, TableColumnType } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectMenus } from '../../layouts/layoutSlice'
import { getMaterialsCategoryName } from '../../models/commodity'
import { Dimen } from '../../models/dimen'
import { decrypt } from '../../models/m'
import { getSupplierCategory } from '../../models/supplierCategory'
import moment from 'moment'
import { DateTimeFormatSimple } from '../../models/datetime'

export const Columns = (
  onclick: (t: any, type: string) => void,
  startIndex: number
): TableColumnType<any>[] => {
  const menus: any = useSelector(selectMenus)

  const menuFlag = menus
    ?.filter((v: any) => v?.name == 'GSP业务')?.[0]
    ?.subMenus?.filter((n: any) => n?.name == '首营管理')?.length
    ? true
    : false

  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '供应商名称',
      align: 'center',
      dataIndex: 'companyName',
      width: Dimen.SupplierName,
      sorter: (a, b) => {
        return a.companyName.length - b.companyName.length
      },
    },
    {
      title: '企业编号',
      align: 'center',
      dataIndex: 'companyCode',
      width: Dimen.Code,
    },
    {
      title: '许可证类型',
      align: 'center',
      dataIndex: 'licenceCategory',
      width: Dimen.Category,
      render: (licenceCategory) => {
        return getSupplierCategory(licenceCategory)
      },
    },
    {
      title: '供应商类型',
      align: 'center',
      dataIndex: 'supplierCategory',
      width: Dimen.Category,
      render: (_, t) => {
        return t.supplierCategory ? '生产厂家' : '供应商'
      },
    },
    {
      title: '许可证号',
      align: 'center',
      dataIndex: 'licenceNumber',
      width: Dimen.Coding,
    },
    {
      title: '有效期',
      align: 'center',
      dataIndex: 'licenceDeadline',
      width: Dimen.Coding,
      sorter: true,
      render: (_, r) => {
        return r?.licenceDeadline ? moment(r?.licenceDeadline).format(DateTimeFormatSimple) : '-'
      },
    },
    {
      title: '地址',
      align: 'center',
      dataIndex: 'address',
    },
    {
      title: '联系电话',
      align: 'center',
      dataIndex: 'phone',
      width: Dimen.TelPhone,
      render: (_, r) => {
        return r?.phone ? decrypt(r?.phone) : '-'
      },
    },
    {
      title: '供货物资类别',
      align: 'center',
      dataIndex: '',
      width: Dimen.Category,
      render: (_, t) => {
        try {
          const arr = JSON.parse(t.supplierMaterialsCategory as string)
          return Array.isArray(arr)
            ? arr.map((v) => getMaterialsCategoryName(Number(v))).join('，')
            : getMaterialsCategoryName(Number(arr))
        } catch {
          return ''
        }
      },
    },
    {
      title: '法人委托书有效期',
      align: 'center',
      dataIndex: 'legalAuthDeadline',
      width: Dimen.Time,
      render: (_, r) => {
        return r?.legalAuthDeadline ? moment(r?.legalAuthDeadline).format(DateTimeFormatSimple) : '-'
      },
    },
    {
      title: '附件',
      align: 'center',
      dataIndex: '',
      width: '6rem',
      render: function showPic(_, t) {
        return t?.fileUrl ? (
          <a
            onClick={() => {
              onclick(t, 'lookPic')
            }}
          >
            查看
          </a>
        ) : (
          '-'
        )
      },
    },
    {
      title: '操作',
      align: 'center',
      dataIndex: '',
      width: '8rem',
      key: 'x',
      render: function edit(_, t) {
        return (
          <div>
            <a
              onClick={(e) => {
                onclick(t, 'edit')
              }}
            >
              编辑
            </a>
            {t.tenantId && t.tenantId > 0 ? (
              <Space>
                {
                  <Popconfirm
                    title='确认进行此操作？'
                    onConfirm={() => onclick(t, 'delete')}
                    okText='确认'
                    cancelText='取消'
                  >
                    <a style={{ margin: '0 0 0 10px' }}>删除</a>
                  </Popconfirm>
                }
              </Space>
            ) : (
              ''
            )}
            {menuFlag && t.tenantId && t.tenantId > 0 ? (
              <Button
                type='primary'
                style={{ margin: '0 0 0 10px' }}
                disabled={t?.fsrId > 0 ? true : false}
                size='small'
                onClick={() => {
                  onclick(t, 'firstBusssiess')
                }}
              >
                首营
              </Button>
            ) : (
              ''
            )}
          </div>
        )
      },
    },
  ]
}

export const SupplierColumns = (): TableColumnType<any>[] => {
  return [
    {
      dataIndex: 'storehouseName',
    },
  ]
}
